// extracted by mini-css-extract-plugin
export default {"content":"content_hFlzi","left":"left_GKZQu"};